import React, {useState} from "react";
import {Tag, message} from "antd";
import {useStore} from "hooks/useStore";
import {ViewContractFileModal} from "components/_defaultComponents/SubCompanyPaymentContractsTable/ViewContractFileModal/ViewContractFileModal";

const EQUIPMENT_CONTRACT_NAME = "courierEquipmentAgreement";

const statusConfig = {
    approved: {color: "green", text: "Onaylı"},
    pendingApproval: {color: "orange", text: "Onay Bekliyor"}
};

const EquipmentContractStatusTag = ({courier}) => {
    const stores = useStore();
    const [viewerVisible, setViewerVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);

    const {contractStatus, contractId} = courier?.equipmentInfo || {};
    const {color, text} = statusConfig[contractStatus] || {
        color: "orange",
        text: "Sözleşme Beklemede"
    };

    // Sözleşme yüklenmemişse gösterilecek dosya da yok.
    if (!contractId) {
        return <Tag color={color}>{text}</Tag>;
    }

    // Kurye listesi cevabı sözleşme dosyalarını içermiyor, sadece contractId geliyor.
    // Dosyaları tıklama anında kuryenin sözleşme listesinden çekip eşleştiriyoruz.
    const handleClick = async () => {
        setViewerVisible(true);
        setLoading(true);
        try {
            const contracts = await stores.contractStore.getCourierContracts({
                courierId: courier?._id,
                limit: 100
            });
            const contract =
                (contracts || []).find(item => item?._id?.toString() === contractId?.toString()) ||
                (contracts || []).find(
                    item =>
                        item?.contractName === EQUIPMENT_CONTRACT_NAME ||
                        item?.templateId?.contractName === EQUIPMENT_CONTRACT_NAME
                );

            if (!contract?.files?.length) {
                message.warning("Sözleşme dosyası bulunamadı");
                setViewerVisible(false);
                return;
            }
            setFiles(contract.files);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tag
                color={color}
                style={{cursor: "pointer", textDecoration: "underline"}}
                onClick={handleClick}
                data-testid="equipmentContractStatusTag"
            >
                {text}
            </Tag>
            <ViewContractFileModal
                visible={viewerVisible}
                loading={loading}
                files={files}
                onCancel={() => {
                    setViewerVisible(false);
                    setFiles([]);
                }}
            />
        </>
    );
};

export default EquipmentContractStatusTag;
